<script setup lang="ts">
import { useField } from 'vee-validate';

const props = defineProps<{
  source: string;
  color: string;
  altText: string;
}>();

const { value: colorValue } = useField<string>(props.color);
</script>
<template>
  <div class="logo">
    <img :src="props.source" :alt="props.altText" />
  </div>
</template>
<style lang="scss">
.logo {
  background-color: v-bind(colorValue);
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 112px;
  width: 112px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

  img {
    max-width: 80%;
    max-height: 80%;
  }
}
</style>
